import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { NavbarLandingPage } from "../../../components";
import { useSettings } from "@/context/SettingsProvider";

export const LandingPageLayout = (props) => {
  const { t } = useTranslation();
  const settingsStore = useSettings();
  const { settings } = settingsStore;

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>{settings.site_title}</title>
        <meta name="description" content={settings.site_description} />
        <link rel="icon" href={settings.site_icon} />
      </Helmet>

      <NavbarLandingPage />
      <main className="flex-grow">{props.children}</main>
      <footer className="border-t py-8 bg-secondary/55">
        <div className="container mx-auto px-4 text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Pairvio. {t("landing.footer.rights")}</p>
          <p className="text-sm mt-2 space-x-4">
            <a href="/terms" className="hover:underline">{t("landing.footer.terms")}</a>
            <a href="/privacy" className="hover:underline">{t("landing.footer.privacy")}</a>
            <a href="/ai-disclaimer" className="hover:underline">{t("landing.footer.aiDisclaimer")}</a>
          </p>
          <p className="text-xs mt-3 max-w-xl mx-auto">
            {t("landing.footer.disclaimer")}
          </p>
        </div>
      </footer>
    </div>
  );
};
